var map = {
	"./accountDeletion.md": "pyZt",
	"./empty.md": "I12p",
	"./indexAboutus.md": "iGQd",
	"./privacypolicy.md": "0baK",
	"./termsservice.md": "wRq9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fuwu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/md ^\.\/.*\.md$
// module id = fuwu
// module chunks = 1